import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import * as ReactSpark from "react-spark";
import FooterDisclaimer from "./components/FooterDisclaimer";
import { isProd } from "../../../util/environment/environment";

const { Divider, Footer, Icon, Link, Stack, List, Type } = ReactSpark;

class AppFooter extends Component {
  render() {
    const {
      appRoot,
      appUrl,
      rocketMoneyLogo,
      rocketMortgageLogo,
      rocketHomesLogo,
      EHOLogo,
      facebookLogo,
      twitterLogo,
      instagramLogo,
      mailLogo,
    } = this.props;
    return (
      <Footer id="footer" size="medium" padding="flush" className="sprk-17-c-Footer">
        <Stack
          data-id="footer-nav"
          itemSpacing="medium"
          splitAt="medium"
          className="sprk-o-Stack__item sprk-u-PaddingTop--b"
        >
          <Stack.Item
            breakpoint="medium"
            width="three-tenths"
            className="sprk-o-Stack sprk-o-Stack--misc-b sprk-o-Box sprk-u-prh"
          >
            <h3 className="sprk-o-Stack__item sprk-b-TypeBodyOne">
              Our Sister Companies
            </h3>
            <Link href="https://www.rocketmortgage.com/?utm_medium=referral&utm_source=loans&utm_campaign=RKTOffers&utm_content=Footer&utm_audience=refer&c=FOCP_RKTOffers&p=RLLD_Footer&qls=FOC_referral.rktloanftr" variant="plain">
              <img
                src={rocketMortgageLogo}
                alt="Rocket Mortgage"
                title="Rocket Mortgage"
                height="20"
                width="184.69"
              />
            </Link>
            <Type.BodyFour>
                Buy a home, refinance or manage your mortgage online with America’s largest mortgage lender
                <sup>1</sup>
            </Type.BodyFour>
            <br />
            <Link href="https://www.rockethomes.com/?utm_medium=referral&utm_source=loans&utm_campaign=RKTOffers&utm_content=Footer&utm_audience=refer&c=FOCP_RKTOffers&p=RLLD_Footer&qls=FOC_referral.rktloanftr" variant="plain">
              <img
                src={rocketHomesLogo}
                alt="Rocket Homes"
                title="Rocket Homes"
                height="16"
                width="159.52"
              />
            </Link>
            <Type.BodyFour>
              Get a real estate agent handpicked for you and search the latest
              home listings
            </Type.BodyFour>
            <br />
            <Link href="https://www.rocketmoney.com/?utm_medium=referral&utm_source=loans&utm_campaign=RKTOffers&utm_content=Footer&utm_audience=refer&c=FOCP_RKTOffers&p=RLLD_Footer&qls=FOC_referral.rktloanftr" variant="plain">
              <img
                src={rocketMoneyLogo}
                alt="Rocket Money"
                title="Rocket Money"
                height="20"
                width="160"
              />
            </Link>
            <Type.BodyFour>
              Save more, spend less, see everything, and take back control of your financial life
            </Type.BodyFour>
          </Stack.Item>
          <Stack.Item
            breakpoint="medium"
            width="seven-tenths"
            className="sprk-o-Stack sprk-o-Stack--medium"
          >
            <Stack
              itemSpacing="medium"
              splitAt="medium"
              className="sprk-o-Stack__item"
            >
              <Stack.Item
                breakpoint="medium"
                width="third"
                className="sprk-o-Box sprk-u-PaddingRight--a sprk-o-Stack sprk-o-Stack--large"
              >
                <h3 className="sprk-o-Stack__item sprk-b-TypeBodyOne">
                  Rocket Loans
                </h3>
                <List
                  variant="bare"
                  size="medium"
                  className="sprk-o-Stack__item sprk-o-Stack sprk-o-Stack--misc-a"
                >
                  <li className="sprk-o-Stack__item">
                    <Link href={`${appRoot}/about-us`} variant="simple">
                      About Us
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link href={`${appUrl}faq`} variant="simple">
                      FAQ
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link href="https://www.trustpilot.com/review/rocketloans.com" variant="simple" target="_blank"
                          rel="noreferrer">
                    Reviews
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link href="https://www.rocketcompanies.com/social-impact/" variant="simple" target="_blank"
                          rel="noopener">
                    Social Impact
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link href="https://rocket.com/" variant="simple" target="_blank"
                          rel="noopener">
                    Rocket
                    </Link>
                  </li>
                </List>
                <br />
                <h3 className="sprk-o-Stack__item sprk-b-TypeBodyOne">
                  Connect With Us
                </h3>
                <List
                  variant="bare"
                  size="medium"
                  className="sprk-o-Stack__item--flex@m sprk-o-Stack sprk-o-Stack--split@xxs"
                >
                  <li className="sprk-o-Stack__item">
                    <Link
                      href="http://www.facebook.com/rocketloans"
                      variant="plain"
                    >
                      <img src={facebookLogo} height="32"/>
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link
                      href="http://www.instagram.com/rocketloans"
                      variant="plain"
                    >
                      <img src={instagramLogo} height="32"/>
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link
                      href="http://www.twitter.com/rocketloans"
                      variant="plain"
                    >
                      <img src={twitterLogo} height="32"/>
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link
                      href="mailto:support@rocketloans.com?Subject=Talk%20to%20Us"
                      variant="plain"
                    >
                      <img src={mailLogo} height="32"/>
                    </Link>
                  </li>
                </List>
              </Stack.Item>
              <Stack.Item
                breakpoint="medium"
                width="third"
                className="sprk-o-Box sprk-u-PaddingRight--a sprk-o-Stack sprk-o-Stack--large"
              >
                <h3 className="sprk-o-Stack__item sprk-b-TypeBodyOne">
                  Personal Loans
                </h3>
                <List
                  variant="bare"
                  size="medium"
                  className="sprk-o-Stack__item sprk-o-Stack sprk-o-Stack--misc-a"
                >
                  <li className="sprk-o-Stack__item">
                    <Link
                      href={`${appRoot}/types-of-personal-loans`}
                      variant="simple"
                    >
                      Personal Loan Uses
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link href={`${appRoot}/personal-loans`} variant="simple">
                      Personal Loans
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link href={`${appUrl}loan-calculator`} variant="simple">
                      Loan Calculator
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link href={`${appUrl}fees`} variant="simple">
                      Fee Schedule
                    </Link>
                  </li>
                </List>
              </Stack.Item>
              <Stack.Item
                breakpoint="medium"
                width="third"
                className="sprk-o-Box sprk-u-PaddingRight--a sprk-o-Stack sprk-o-Stack--large"
              >
                <h3 className="sprk-o-Stack__item sprk-b-TypeBodyOne">Legal</h3>
                <List
                  variant="bare"
                  size="medium"
                  className="sprk-o-Stack__item sprk-o-Stack sprk-o-Stack--misc-a"
                >
                  <li className="sprk-o-Stack__item">
                    <Link
                      href="https://static.rocketloans.com/disclosures/patriot-act.pdf"
                      variant="simple"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Customer Notice
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link href={`${appUrl}terms-of-service`} variant="simple">
                      Terms Of Use
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link
                      href="https://rocketaccount.com/#/privacy-policy"
                      variant="simple"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link
                      href="https://www.rocketaccount.com/#/privacy-policy#information-we-collect"
                      variant="simple"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Notice at Collection
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link
                      href={`${appRoot}/disclosures-and-licenses`}
                      variant="simple"
                    >
                      Disclosures and Licenses
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    <Link
                      href={`${appRoot}/accessibility`}
                      variant="simple"
                    >
                      Accessibility
                    </Link>
                  </li>
                  <li className="sprk-o-Stack__item">
                    {/* span element for TrustArc cookie management script target */}
                    <span id={window.globalConfig.cookieManagerElementId}>
                      <Link
                        href="https://rocketaccount.com/#/do-not-sell-my-personal-information"
                        variant="simple"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        Do Not Sell or Share My Personal Information
                      </Link>
                    </span>
                  </li>
                </List>
              </Stack.Item>
            </Stack>
          </Stack.Item>
        </Stack>
        <Divider className="sprk-u-mvn sprk-u-mhm" />
        <Stack
          data-id="footer-disclaimer"
          itemSpacing="medium"
          splitAt="medium"
          className="sprk-o-Stack__item sprk-o-Stack--misc-b sprk-u-PaddingTop--b"
        >
          <Stack.Item className="sprk-o-Stack sprk-o-Stack--large sprk-o-Box">
            <FooterDisclaimer
              appUrl={appUrl}
              EHOLogo={EHOLogo}
            />
          </Stack.Item>
        </Stack>
      </Footer>
    );
  }
}

AppFooter.propTypes = {
  appRoot: PropTypes.string.isRequired,
  appUrl: PropTypes.string.isRequired,
  rocketMoneyLogo: PropTypes.string.isRequired,
  rocketMortgageLogo: PropTypes.string.isRequired,
  rocketHomesLogo: PropTypes.string.isRequired,
  EHOLogo: PropTypes.string.isRequired,
  facebookLogo: PropTypes.string.isRequired,
  twitterLogo: PropTypes.string.isRequired,
  instagramLogo: PropTypes.string.isRequired,
  mailLogo: PropTypes.string.isRequired
};

AppFooter.FooterDisclaimer = FooterDisclaimer;

export default AppFooter;
